var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
import { v1 } from "@variable/ui-icons/";
import Fuse from 'fuse.js';
var ROWS_PER_PAGE = 10;
var ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 200];
var ROWS_PER_PAGE_STORAGE_KEY = "VariableHub.MuiTable.rowsPerPage";
var getRowsPerPage = function () {
    var rowsPerPage = localStorage.getItem(ROWS_PER_PAGE_STORAGE_KEY);
    return rowsPerPage ? parseInt(rowsPerPage) : ROWS_PER_PAGE;
};
var setRowsPerPage = function (rowsPerPage) {
    localStorage.setItem(ROWS_PER_PAGE_STORAGE_KEY, rowsPerPage.toString());
};
var DefaultSearch = function (query, keys, data) {
    if (query === "")
        return true;
    var fuse = new Fuse([data], {
        includeScore: true,
        ignoreLocation: true,
        useExtendedSearch: true,
        findAllMatches: true,
        keys: keys
    });
    var result = fuse.search(query);
    return result && result.length > 0 && result[0] && result[0].score && result[0].score < 0.2;
};
var TableOptions = {
    responsive: "vertical",
    rowHover: false,
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: false,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
    // rowsPerPage: getRowsPerPage(),
    // onChangeRowsPerPage: setRowsPerPage,
};
var TableHeadRender = function (columnMeta, updateDirection) {
    var _a, _b, _c;
    var cellHeaderProps = columnMeta.setCellHeaderProps ? columnMeta.setCellHeaderProps(columnMeta) : { style: { maxWidth: "auto", width: "auto", textAlign: "center" } };
    return (_jsx("th", __assign({ onClick: function () { return updateDirection(columnMeta.index); }, style: { height: "50px", maxWidth: ((_a = cellHeaderProps === null || cellHeaderProps === void 0 ? void 0 : cellHeaderProps.style) === null || _a === void 0 ? void 0 : _a.maxWidth) || "auto", width: ((_b = cellHeaderProps === null || cellHeaderProps === void 0 ? void 0 : cellHeaderProps.style) === null || _b === void 0 ? void 0 : _b.width) || "auto", textAlign: ((_c = cellHeaderProps === null || cellHeaderProps === void 0 ? void 0 : cellHeaderProps.style) === null || _c === void 0 ? void 0 : _c.textAlign) || "center", background: "var(--palette-offwhite-1) 0% 0% no-repeat padding-box", cursor: 'pointer' } }, { children: _jsxs("div", __assign({ style: { paddingLeft: "16px", display: "block", color: "black" } }, { children: [columnMeta.label ? columnMeta.label : columnMeta.name, _jsx("div", __assign({ style: { display: "inline", padding: "5px" } }, { children: _jsx(v1.SortIcon, {}) }))] })) }), columnMeta.index));
};
var customSearch = function (searchKeys, searchQuery, currentRow, columns) {
    var hash = {};
    currentRow.forEach(function (r, index) { hash[index] = r; });
    return DefaultSearch(searchQuery, searchKeys, hash);
};
var Table = function (props) {
    var _a = useState(__assign(__assign({}, props.options), { customSearch: Array.isArray(props.searchKeys) ?
            function (searchQuery, currentRow, columns) {
                return customSearch(props.searchKeys, searchQuery, currentRow, columns);
            }
            : undefined })), options = _a[0], setOptions = _a[1];
    useEffect(function () {
        setOptions(__assign(__assign({}, props.options), { customSearch: Array.isArray(props.searchKeys) ?
                function (searchQuery, currentRow, columns) {
                    return customSearch(props.searchKeys, searchQuery, currentRow, columns);
                }
                : undefined }));
    }, [props.options]);
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: props.data.length > 0 && options &&
            _jsx(MUIDataTable, { title: props.title, data: props.data, columns: props.columns, options: options }) })));
};
export { Table, TableHeadRender, TableOptions, customSearch };
